export class IntAssessDtl {
  CandID;
  JobAdCode;
  Seq;
  Grp;
  Item;
  Ans;
  Rem;
  constructor() {
    this.CandID = "";
    this.JobAdCode = "";
    this.Seq = "";
    this.Grp = "";
    this.Item = "";
    this.Ans = "";
    this.Rem = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/IntAssessDtl.js